import View from './Page.jsx'
import container from './container.js'

const StockScanner = container(View)
StockScanner.displayName = 'StockScanner'

export default StockScanner
